import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

declare var $:any;

@Component({
  selector: 'app-toppers-meet',
  templateUrl: './toppers-meet.component.html',
  styleUrls: ['../../main-page/main-page.component.scss']
})
export class ToppersMeetComponent {
  @Input('hideButton') hideButton:any = false;
  playVideoFlagStory:boolean = false;
  slider1: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Rishi-Mittal.webp', video: 'd8Datuvi4L4', percent: 'CAT 100%iler', name: 'Rishi Mittal' },
    { img: 'https://media.iquanta.in/ui_images/mayank.webp', video: 'v8O8ELvatPc', percent: 'CAT 99.76%iler', name: 'Mayank' },
    { img: 'https://media.iquanta.in/ui_images/Rahul-Agrawal.webp', video: 'GIrpNkOa8kQ', percent: 'CAT 99.92%iler', name: 'Rahul Agrawal' },
    { img: 'https://media.iquanta.in/ui_images/Karal-Maheshwari.webp', video: 'FjQPFPxlEjc', percent: 'CAT 99%iler', name: 'Karal Maheshwari' },
    { img: 'https://media.iquanta.in/ui_images/Kislay-Jha.webp', video: 'uUUseqANr7w', percent: 'CAT 99.96%iler', name: 'Kislay Jha' },
    { img: 'https://media.iquanta.in/ui_images/Karan-Dutta.webp', video: 'U7v8MmhfaOQ', percent: 'CAT 99.56%iler', name: 'Karan Dutta' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper2.jpg', video: '0udGFVgMd84', percent: 'CAT 99.5%iler', name: '' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper1.jpg', video: 'zHxUBf-yOhk', percent: 'CAT 99.97%iler', name: '' }
  ]

  topperListFeedback: any[] = [
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-1.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-02.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-03.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-04.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-05.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-06.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-07.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-08.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-09.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-10.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-11.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-12.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-13.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-14.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-15.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-16.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-17.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-18.webp',
  ]

  successStories: any[] =
  [{ img: 'https://media.iquanta.in/ui_images/new-home/gursimranprofile-66e81bb7923eb.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/aayishrofile-66e81bb5cb55e.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/karalprofile-66e81bb5d72c5.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/avinashprofile-66e81bb42ccb0.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/shubashishprofile-66e81bb414823.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/biswaruoprofile-66e81bb2746bb.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/gautamprofile-66e81bb28b1c2.webp' },
  { img: 'https://media.iquanta.in/ui_images/new-home/gursimranprofile-66e81bb7923eb.webp' },
  ]

  selectedImg:any;
  selectedIndex:any = 0;
  showContent:boolean = false;
  showContent1:boolean = false;

  constructor( public sanitizer: DomSanitizer) {}


  gotosection(val:any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  openGallery(ind:any){
    this.selectedIndex = ind;
    this.selectedImg = this.topperListFeedback[ind]
    $('#GalleryModal').modal('show')
  }

  prev(){
    if(this.selectedIndex > 0){
      this.selectedIndex--;
    this.selectedImg = this.topperListFeedback[this.selectedIndex]
    }
  }

  next(){
    if(this.selectedIndex < this.topperListFeedback.length - 1){
      this.selectedIndex++;
    this.selectedImg = this.topperListFeedback[this.selectedIndex]
    }
  }
 
  joinwhatsapp(){
    window.open('https://chat.whatsapp.com/J9g4j8G0KL20Qoff2fO0c2', '_blank')
  }

  videoLink: any
  videoPlay(obj: any) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + obj.video + '?rel=0')
    $('#VideoPlayer').modal()
    //  let modal:any = document.getElementById('VideoPlayer')
    //  modal.show()
  }
  

}
